import { PhoneNumber } from "@/libs/apis/onboarding/mfa";

export enum SecureNumberState {
  PHONE_NUMBER,
  VERIFICATION,
}

export enum VerificationMethod {
  EMAIL = "email",
  PHONE_NUMBER = "sms",
}

export type MFAType = {
  mfaState: SecureNumberState;
  phoneNumber: PhoneNumber;
  mfaId: string;
  setMfaId: (mfaId: string) => void;
  setPhoneNumber: (phoneNumber: PhoneNumber) => void;
  setMfaState: (state: SecureNumberState) => void;
  userHasNumber: boolean;
  verificationMethod: VerificationMethod;
  verificationEntity: string;
  reset: () => void;
  setEnabled: (enabled: boolean) => void;
  setVerificationMethod: (state: VerificationMethod) => void;
};
